module.exports = __webpack_public_path__ + "static/media/rules.6b85b488.jpg";